import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_cultura_perfil } from "../../../models";

export const CulturaPerfil = () => {
    const columns = [
        { field: 'cultperfid', header: 'Código', style: { width: '300px' } },
        { field: 'cultdescricao', header: 'Cultura', style: { width: '300px' } },
        { field: 'cultperfdescricao', header: 'Descrição' },
        { field: 'cultperfativo', header: 'Ativo' },
        { field: 'functions', style: { minWidth: '2rem', width: '2rem' } }
    ];

    return (
        <ConsultaPadrao model={model_cultura_perfil} columns={columns} sortField="cultid" />
    )
}